import type { BoxProps } from '@opendoor/bricks-next';
import { Box } from '@opendoor/bricks-next';

type ListVariant = 'text' | 'bullet';

type ListProps = Omit<BoxProps, 'tag'> & {
  variant?: ListVariant;
};

export const List = ({ variant = 'text', '$platform-web': platformWeb, ...props }: ListProps) => {
  const bulletProps: Partial<BoxProps> =
    variant === 'bullet'
      ? { '$platform-web': { listStyleType: 'disc', paddingInlineStart: 20, ...platformWeb } }
      : { '$platform-web': platformWeb };

  return <Box tag="ul" display="block" flexDirection="row" {...bulletProps} {...props} />;
};
